import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.int32-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2019-2022 @polkadot/wasm-bridge authors & contributors
// SPDX-License-Identifier: Apache-2.0

/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { stringToU8a, u8aToString } from '@polkadot/util';
import { Wbg } from "./wbg.js";

var _cachegetInt = /*#__PURE__*/new WeakMap();

var _cachegetUint = /*#__PURE__*/new WeakMap();

var _createWasm = /*#__PURE__*/new WeakMap();

var _heap = /*#__PURE__*/new WeakMap();

var _heapNext = /*#__PURE__*/new WeakMap();

var _wasm = /*#__PURE__*/new WeakMap();

var _wasmError = /*#__PURE__*/new WeakMap();

var _wasmPromise = /*#__PURE__*/new WeakMap();

var _wbg = /*#__PURE__*/new WeakMap();

var _type = /*#__PURE__*/new WeakMap();

export var Bridge = /*#__PURE__*/function () {
  function Bridge(createWasm) {
    _classCallCheck(this, Bridge);

    _classPrivateFieldInitSpec(this, _cachegetInt, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _cachegetUint, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _createWasm, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _heap, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _heapNext, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _wasm, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _wasmError, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _wasmPromise, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _wbg, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _type, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(this, _createWasm, createWasm);

    _classPrivateFieldSet(this, _cachegetInt, null);

    _classPrivateFieldSet(this, _cachegetUint, null);

    _classPrivateFieldSet(this, _heap, new Array(32).fill(undefined).concat(undefined, null, true, false));

    _classPrivateFieldSet(this, _heapNext, _classPrivateFieldGet(this, _heap).length);

    _classPrivateFieldSet(this, _type, 'none');

    _classPrivateFieldSet(this, _wasm, null);

    _classPrivateFieldSet(this, _wasmError, null);

    _classPrivateFieldSet(this, _wasmPromise, null);

    _classPrivateFieldSet(this, _wbg, _objectSpread({}, new Wbg(this)));
  }

  _createClass(Bridge, [{
    key: "error",
    get: function get() {
      return _classPrivateFieldGet(this, _wasmError);
    }
  }, {
    key: "type",
    get: function get() {
      return _classPrivateFieldGet(this, _type);
    }
  }, {
    key: "wbg",
    get: function get() {
      return _classPrivateFieldGet(this, _wbg);
    }
  }, {
    key: "wasm",
    get: function get() {
      return _classPrivateFieldGet(this, _wasm);
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(createWasm) {
        var _yield$_classPrivateF, error, type, wasm;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_classPrivateFieldGet(this, _wasmPromise) || createWasm) {
                  _classPrivateFieldSet(this, _wasmPromise, (createWasm || _classPrivateFieldGet(this, _createWasm))(_classPrivateFieldGet(this, _wbg)));
                }

                _context.next = 3;
                return _classPrivateFieldGet(this, _wasmPromise);

              case 3:
                _yield$_classPrivateF = _context.sent;
                error = _yield$_classPrivateF.error;
                type = _yield$_classPrivateF.type;
                wasm = _yield$_classPrivateF.wasm;

                _classPrivateFieldSet(this, _type, type);

                _classPrivateFieldSet(this, _wasm, wasm);

                _classPrivateFieldSet(this, _wasmError, error);

                return _context.abrupt("return", _classPrivateFieldGet(this, _wasm));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getObject",
    value: function getObject(idx) {
      return _classPrivateFieldGet(this, _heap)[idx];
    }
  }, {
    key: "dropObject",
    value: function dropObject(idx) {
      if (idx < 36) {
        return;
      }

      _classPrivateFieldGet(this, _heap)[idx] = _classPrivateFieldGet(this, _heapNext);

      _classPrivateFieldSet(this, _heapNext, idx);
    }
  }, {
    key: "takeObject",
    value: function takeObject(idx) {
      var ret = this.getObject(idx);
      this.dropObject(idx);
      return ret;
    }
  }, {
    key: "addObject",
    value: function addObject(obj) {
      if (_classPrivateFieldGet(this, _heapNext) === _classPrivateFieldGet(this, _heap).length) {
        _classPrivateFieldGet(this, _heap).push(_classPrivateFieldGet(this, _heap).length + 1);
      }

      var idx = _classPrivateFieldGet(this, _heapNext);

      _classPrivateFieldSet(this, _heapNext, _classPrivateFieldGet(this, _heap)[idx]);

      _classPrivateFieldGet(this, _heap)[idx] = obj;
      return idx;
    }
  }, {
    key: "getInt32",
    value: function getInt32() {
      if (_classPrivateFieldGet(this, _cachegetInt) === null || _classPrivateFieldGet(this, _cachegetInt).buffer !== _classPrivateFieldGet(this, _wasm).memory.buffer) {
        _classPrivateFieldSet(this, _cachegetInt, new Int32Array(_classPrivateFieldGet(this, _wasm).memory.buffer));
      }

      return _classPrivateFieldGet(this, _cachegetInt);
    }
  }, {
    key: "getUint8",
    value: function getUint8() {
      if (_classPrivateFieldGet(this, _cachegetUint) === null || _classPrivateFieldGet(this, _cachegetUint).buffer !== _classPrivateFieldGet(this, _wasm).memory.buffer) {
        _classPrivateFieldSet(this, _cachegetUint, new Uint8Array(_classPrivateFieldGet(this, _wasm).memory.buffer));
      }

      return _classPrivateFieldGet(this, _cachegetUint);
    }
  }, {
    key: "getU8a",
    value: function getU8a(ptr, len) {
      return this.getUint8().subarray(ptr / 1, ptr / 1 + len);
    }
  }, {
    key: "getString",
    value: function getString(ptr, len) {
      return u8aToString(this.getU8a(ptr, len));
    }
  }, {
    key: "allocU8a",
    value: function allocU8a(arg) {
      var ptr = _classPrivateFieldGet(this, _wasm).__wbindgen_malloc(arg.length * 1);

      this.getUint8().set(arg, ptr / 1);
      return [ptr, arg.length];
    }
  }, {
    key: "allocString",
    value: function allocString(arg) {
      return this.allocU8a(stringToU8a(arg));
    }
  }, {
    key: "resultU8a",
    value: function resultU8a() {
      var r0 = this.getInt32()[8 / 4 + 0];
      var r1 = this.getInt32()[8 / 4 + 1];
      var ret = this.getU8a(r0, r1).slice();

      _classPrivateFieldGet(this, _wasm).__wbindgen_free(r0, r1 * 1);

      return ret;
    }
  }, {
    key: "resultString",
    value: function resultString() {
      return u8aToString(this.resultU8a());
    }
  }]);

  return Bridge;
}();